"use client";

import * as React from "react";
import { FileText, Calculator, Users, TrendingUp, Shield, Briefcase } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  title: "Accounting & Bookkeeping",
  description: "Comprehensive accounting services to keep your financial records accurate and up-to-date.",
  icon: FileText,
  link: "/Services#accountingbookkeeping"
}, {
  id: 2,
  title: "Tax Planning & Advisory",
  description: "Strategic tax planning to minimize liabilities and maximize your financial efficiency.",
  icon: Calculator,
  link: "/Services#taxplanningandadvisory"
}, {
  id: 3,
  title: "Payroll Services",
  description: "Efficient payroll management ensuring timely and accurate employee compensation.",
  icon: Users,
  link: "/Services#payrollservices"
}, {
  id: 4,
  title: "Financial Consulting",
  description: "Expert guidance to help you make informed financial decisions for growth.",
  icon: TrendingUp,
  link: "/Services#financialconsulting"
}, {
  id: 5,
  title: "Business Formation",
  description: "Support in structuring your business for optimal legal and tax advantages.",
  icon: Shield,
  link: "/Services#businessformation"
}, {
  id: 6,
  title: "Advisory Services",
  description: "Ongoing strategic advice to navigate complex financial challenges.",
  icon: Briefcase,
  link: "/Services#strategicplanning"
}];
export default function ServiceCategories() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="service-categories" ref={sectionRef} className="w-full bg-background py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-4xl font-bold text-foreground">
            Our Services
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Comprehensive accounting solutions tailored to your business needs
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={service.id} data-index={i} className={`transition-all duration-200 ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <Card className="h-full border border-border bg-surface shadow-soft transition-all duration-150 ease-out hover:-translate-y-0.5 hover:shadow-medium hover:bg-primary-light/30">
                  <CardHeader className="pb-4">
                    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-lg bg-primary-light">
                      <Icon className="h-7 w-7 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="mb-4 text-muted-foreground">
                      {service.description}
                    </p>
                    <Link to={service.link} className="inline-flex items-center text-sm font-semibold text-accent transition-colors duration-150 hover:text-accent-hover focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring">
                      Learn More
                      <svg className="ml-1 h-4 w-4 transition-transform duration-150 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}